module.exports = __webpack_public_path__ + "static/media/step3d.73e7b703.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/step3d.png
// module id = 3735
// module chunks = 0